// extracted by mini-css-extract-plugin
export default {"subject-list-main__pagination":"SubjectListPagination_subject-list-main__pagination__WoeBd"};